export default class ECMStorage {
  _data = [];

  constructor(adapter, name) {
    this.adapter = adapter;
    this._name = name;
    this._storageKey = `beans-snow-${this._name}`;
    this._data = JSON.parse(this.adapter.getItem(this._storageKey)) || [];
  }

  _save() {
    this.adapter.setItem(this._storageKey, JSON.stringify(this._data));
  }

  all() {
    return this._data;
  }

  get(id) {
    return this.all().filter((item) => item.id === id)[0];
  }

  create(item) {
    if (this.get(item.id)) {
      this.update(item.id, item);
      return this.get(item.id);
    }
    this._data.push(item);
    this._save();
    return item;
  }

  update(id, data) {
    this._data = this.all().map((element) => (element.id === id ? Object.assign(element, data) : element));
    this._save();
  }

  updateAll(data) {
    this.all().forEach((item) => {
      this.update(item.id, data);
    });
  }

  delete(id) {
    this._data = this.all().filter((item) => item.id !== id);
    this._save();
  }

  clear() {
    this.adapter.removeItem(this._storageKey);
  }
}
